import type { ReactNode } from "react";

export { FEATURE_KEYS } from "../../config/features";

export type FeatureKey = string;

// Each deployed application owns a full feature copy, so no runtime plan gate is needed.
export const hasFeature = (_feature?: FeatureKey) => true;

export const FeatureGate = ({ children }: { feature?: FeatureKey; children: ReactNode }) => (
    <>{children}</>
);
